import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { Helmet } from 'react-helmet-async'

import CustomPaper from '@/components/custom-paper'
import MunicipalityFinancesTabs from '@/components/municipality-finances/tabs'
import MunicipalityPermissionGate from '@/components/municipality-permission-gate'

function FinancesView() {

    const title = 'Hospodaření obce'

    return (
        <>
            <Helmet>
                <title>{title}</title>
            </Helmet>
            <CustomPaper noPadding>
                <Box p={2.5}>
                    <Typography variant="h2" component="h1">
                        {title}
                    </Typography>
                </Box>
                <MunicipalityPermissionGate>
                    <MunicipalityFinancesTabs />
                </MunicipalityPermissionGate>
            </CustomPaper>
        </>
    )
}

export default FinancesView
